import moment from "moment";
import { ActiveUser } from "@/services/user";
import { locales } from "@/locales";

export const LanguageMixin = {
  computed: {
    languages() {
      return Object.keys(locales).map((locale) => ({
        label: locale.toUpperCase(),
        value: locale,
      }));
    },
  },
  mounted() {
    const queryLanguage = this.$route?.query.lang;
    const language = ActiveUser.getLanguage();
    if (language) {
      this.setLanguage(language);
    }
    if (queryLanguage) {
      this.setLanguage(queryLanguage);
    }
  },
  methods: {
    async setLanguage(value) {
      value = value.toLowerCase()
      await ActiveUser.setLanguage(value);
      moment.locale(value);
      this.$i18n.locale = value;
    },
  },
};
